import { getParams } from "../utils/helpers";
import { pageLocale } from "./locale";

const { locale } = getParams();
const { good_cap, average_cap, poor_cap, good, moderate, bad } =
  pageLocale("newreport");

const isCJK = locale === "ja" || locale === "zh";

export const dateFormater = (recorddate) => {
  const date = new Date(recorddate);
  if (isCJK) {
    return (
      date.getUTCFullYear() +
      "年" +
      (date.getUTCMonth() + 1) +
      "月" +
      date.getUTCDate() +
      "日"
    );
  }
  if (locale === "en") {
    return (
      (date.getUTCMonth() + 1).toString().padStart(2, 0) +
      "/" +
      date.getUTCDate().toString().padStart(2, 0) +
      "/" +
      date.getUTCFullYear()
    );
  }
  return (
    date.getUTCFullYear() +
    "/" +
    (date.getUTCMonth() + 1).toString().padStart(2, 0) +
    "/" +
    date.getUTCDate().toString().padStart(2, 0)
  );
};

export const dateFormatWithYear = (recorddate) => {
  const date = new Date(recorddate);
  if (isCJK) {
    return (
      date.getUTCFullYear() +
      "年" +
      (date.getUTCMonth() + 1) +
      "月" +
      date.getUTCDate() +
      "日"
    );
  }
  const monthNames = [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec",
  ];
  return (
    monthNames[date.getUTCMonth()] +
    " " +
    date.getUTCDate().toString().padStart(2, 0) +
    ", " +
    date.getUTCFullYear()
  );
};

export const dateFormaterWithMonth = (recorddate) => {
  const date = new Date(recorddate);
  if (isCJK) {
    return date.getUTCMonth() + 1 + "月" + date.getUTCDate() + "日";
  }
  const monthNames = [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec",
  ];
  return (
    monthNames[date.getUTCMonth()] +
    " " +
    date.getUTCDate().toString().padStart(2, 0)
  );
};

// The API returns each metric's `range[]` in best→worst order with a
// localized `type` string ("Good"/"Average"/"Poor" in EN, "良好"/"注意"/
// "要注意" in JA, etc.). Tag each entry with a stable severity key so
// downstream UI can branch on it without doing string equality on the
// localized label.
export const attachSeverity = (range) => {
  if (!Array.isArray(range) || range.length === 0) return range;
  const map =
    range.length === 1
      ? ["good"]
      : range.length === 2
      ? ["good", "poor"]
      : ["good", "average", "poor"];
  return range.map((r, i) => ({ ...r, severity: map[i] || "poor" }));
};

// Resolve a metric's severity from the API-provided localized `type`
// by looking it up in its range[] (which must already have severity
// attached via attachSeverity).
export const severityForType = (type, range) => {
  if (!type || !Array.isArray(range)) return null;
  return range.find((r) => r.type === type)?.severity || null;
};

export const worstSeverity = (severities) => {
  const order = { poor: 0, average: 1, good: 2 };
  let worst = null;
  severities.forEach((severity) => {
    if (!severity) return;
    if (worst === null || order[severity] < order[worst]) {
      worst = severity;
    }
  });
  return worst;
};

export const statusHandler = (val) => {
  switch (val) {
    case good_cap:
      return "#34C203";
    case average_cap:
      return "#FFA800";
    case poor_cap:
      return "#FF0000";
    case good:
      return "#34C203";
    case moderate:
      return "#FFA800";
    case bad:
      return "#FF0000";
    case "good":
      return "#34C203";
    case "moderate":
      return "#FFA800";
    case "bad":
      return "#FF0000";
  }
};
